module.exports = __webpack_public_path__ + "static/gestion-3428cb223ecd9a1000cf8273fe8b6b09.png";